/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.StatementController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { CcpsRequest } from '../models/ccps-request';
import { SummaryRequest } from '../models/summary-request';
import {CcpsResponse} from "zorroapiclient/lib/models/ccps-response";

@Injectable()
export class StatementApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }


    public requestCcps(request: CcpsRequest, spinnerMessage: string = null): Observable<CcpsResponse> {
        return this.httpClient.post<CcpsResponse>(`/api/statement/ccps`, request,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public requestSummary(request: SummaryRequest, spinnerMessage: string = null): Observable<CcpsResponse> {
        return this.httpClient.post<CcpsResponse>(`/api/statement/summary`, request,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

}
